import { AnyAction } from "redux";
import { initialState } from "../store/initialState";
import { actionTypeKeys } from "../actions/actionTypeKeys";
import { Representative } from "../../common/types/representative";

export default function representativesReducer(
  state: Representative[] = initialState.availableServiceReps,
  action: AnyAction
): Representative[] {
  switch (action.type) {
    case actionTypeKeys.LOAD_REPRESENTATIVES_SUCCESS:
      return [...action.representatives];
    default:
      return state;
  }
}
